import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

class PrivateRoute extends Component {
  static propTypes = {
    loginedIn: PropTypes.bool.isRequired
  };

  renderRoute = props => {
    const { loginedIn, component: Component, location } = this.props;
    if (loginedIn) {
      // If path is equal to "/" redirect to profile page
      if (location.pathname === "/") {
        return (
          <Redirect
            to={{
              pathname: "/profile",
              state: { from: location }
            }}
          />
        );
      }
      return <Component {...props} />;
    }
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: location }
        }}
      />
    );
  };

  render() {
    const { component, ...rest } = this.props;
    return <Route {...rest} render={this.renderRoute} />;
  }
}

const mapStateToProps = state => {
  const { loginedIn } = state.auth;
  return { loginedIn };
};

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/utils/privateRoute.js